import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { uploadBackground } from '@shoflo/studio-redux/actions';
import { useModal } from 'hooks';

import {
  BACKGROUND_FORM,
  IMAGE_FILE,
  getFileSourceType,
  validateImageDimensions
} from '@shoflo/polymer';

import {
  Form,
  Label,
  Button,
  FormGroup,
  FormFeedback,
  Row,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';

import {
  StyledCloseButton,
  StyledAllowedMediaTypes,
  StyledFileInputCol,
  StyledAllowedMediaCol,
  StyledInput
} from './BackgroundForm.styled';

function BackgroundForm() {
  const dispatch = useDispatch();
  const { isOpen, clear } = useModal(BACKGROUND_FORM);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState(null);
  const [isFileValid, setIsFileValid] = useState(true);
  const handleSubmit = useCallback(
    event => {
      event.preventDefault();
      const layer = {
        title,
        type: IMAGE_FILE,
        file
      };
      dispatch(uploadBackground(layer));
      clear();
      setTitle(null);
      setFile(null);
      setIsFileValid(true);
    },
    [title, file, dispatch, clear]
  );

  const handleFileChange = useCallback(async event => {
    const file = event.target.files[0];
    const isImageFile = getFileSourceType(file?.name) === IMAGE_FILE;
    if (isImageFile && (await validateImageDimensions(file))) {
      setFile(file);
      setTitle(file.name);
      setIsFileValid(true);
    } else {
      setTitle(null);
      setFile(null);
      setIsFileValid(false);
    }
  }, []);

  const supportedFileTypes =
    'jpeg, png, bmp, gif (5mb per file size limit)\nImages can be no larger than 1920x1080 px.';

  return (
    <Modal isOpen={isOpen} toggle={clear}>
      <ModalHeader>Add background</ModalHeader>
      <ModalBody>
        <Form data-testid="backgroundCreateForm" onSubmit={handleSubmit}>
          <Row>
            <StyledFileInputCol md={5}>
              <FormGroup>
                <Label id="backgroundFileLabel" htmlFor="backgroundFileFile">
                  Upload new background
                </Label>

                <StyledInput
                  data-testid="backgroundFileInput"
                  type="file"
                  aria-labelledby="backgroundFileLabel"
                  name="file"
                  onChange={handleFileChange}
                  id="backgroundFileFile"
                  invalid={!isFileValid}
                  accept=".png, .bmp, .jpeg, .jpg, .gif"
                />
                <FormFeedback>
                  Uh oh! A valid image file is required.
                </FormFeedback>
              </FormGroup>
            </StyledFileInputCol>
            <StyledAllowedMediaCol>
              <StyledAllowedMediaTypes>
                {supportedFileTypes}
              </StyledAllowedMediaTypes>
            </StyledAllowedMediaCol>
          </Row>

          <FormGroup>
            <div className="float-end">
              <Button
                data-testid="addButton"
                color="primary"
                disabled={!file || !isFileValid}
                data-dd-action-name="Save Background"
              >
                Save
              </Button>{' '}
              <StyledCloseButton
                data-testid="closeButton"
                color="default"
                onClick={clear}
                data-dd-action-name="Close Upload Background Form"
              >
                Close
              </StyledCloseButton>
            </div>
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
}

export default BackgroundForm;
